module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector"
  }, [_c('div', {
    staticClass: "tab-selector"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      selected: _vm.isPetition
    },
    on: {
      "click": function($event) {
        _vm.updateSelection('petition')
      }
    }
  }, [_c('div', {
    staticClass: "select-img"
  }, [(_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2612/dist/assets/img/ra-tree-plain.svg"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2612/dist/assets/img/ra-tree-hollow.svg"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_vm._v("\n        " + _vm._s(_vm.petitionSelector) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      selected: !_vm.isPetition
    },
    on: {
      "click": function($event) {
        _vm.updateSelection('donation')
      }
    }
  }, [_c('div', {
    staticClass: "select-img"
  }, [(!_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2612/dist/assets/img/ra-forest-plain.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPetition) ? _c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2612/dist/assets/img/ra-forest-hollow.svg"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cell"
  }, [_vm._v("\n        " + _vm._s(_vm.donationSelector) + "\n      ")])])]), _vm._v(" "), (_vm.isPetition) ? _c('div', {
    staticClass: "petition-handle"
  }, [_vm._v(_vm._s(_vm.petitionHandle))]) : _vm._e(), _vm._v(" "), (_vm.isDonation) ? _c('div', [_c('div', {
    staticClass: "dollar-handle-selector"
  }, [_vm._l((_vm.dollarHandles), function(dollarHandle) {
    return _c('label', {
      attrs: {
        "for": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDollarHandle),
        expression: "selectedDollarHandle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle-' + _vm.currentDonationType,
        "id": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount,
        "data-vv-as": "amount"
      },
      domProps: {
        "value": dollarHandle,
        "checked": _vm._q(_vm.selectedDollarHandle, dollarHandle)
      },
      on: {
        "change": function($event) {
          _vm.selectedDollarHandle = dollarHandle
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDollarHandle(dollarHandle.amount)))])])])
  }), _vm._v(" "), (_vm.proposeCustomAmount) ? _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDollarHandle),
      expression: "selectedDollarHandle"
    }],
    attrs: {
      "type": "radio",
      "name": 'handle-' + _vm.currentDonationType,
      "id": 'handle-' + _vm.currentDonationType + '-custom',
      "value": "custom"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedDollarHandle, "custom")
    },
    on: {
      "change": function($event) {
        _vm.selectedDollarHandle = "custom"
      }
    }
  }), _vm._v(" "), _vm._m(0, false, false)]) : _vm._e()], 2), _vm._v(" "), (_vm.isCustomSelected) ? _c('div', [_c('div', {
    staticClass: "wwf-field icon"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.amount),
      expression: "donation.amount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        leafReliefCustomAmountIsValid: true,
      }),
      expression: "{\n            required: true,\n            leafReliefCustomAmountIsValid: true,\n          }"
    }],
    ref: "customAmount",
    class: {
      'border-red': _vm.errors.has('custom-amount')
    },
    attrs: {
      "id": "custom-amount",
      "name": "custom-amount",
      "type": "number"
    },
    domProps: {
      "value": (_vm.donation.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_vm._v("\n          Custom amount\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(
    _vm.errors.firstByRule(
      'custom-amount',
      'leafReliefCustomAmountIsValid'
    )
  ) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("custom-amount")) + "\n          ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaxAmountMessage),
      expression: "showMaxAmountMessage"
    }],
    staticClass: "message-max-amount"
  }, [_c('p', [_vm._v("\n        For donations above $75,000 please contact our Impact Partnerships\n        team, so we can be sure your gift benefits the area of conservation\n        you are most passionate about.\n      ")]), _vm._v(" "), _vm._m(2, false, false)]), _vm._v(" "), (_vm.isDollarHandleSelected) ? _c('div', {
    staticClass: "dollar-handle-selected"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDollarHandle.text))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('handle-' + _vm.currentDonationType)) ? _c('p', [_vm._v("\n        Please choose your donation amount\n      ")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Please email\n        "), _c('a', {
    attrs: {
      "href": "mailto:partnerships@wwf.org.au",
      "target": "_blank"
    }
  }, [_vm._v("\n          partnerships@wwf.org.au\n        ")]), _vm._v("\n        . Thank you so much for your kindness!\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-515e5eba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=bhy68egj1x!./~/string-replace-webpack-plugin/loader.js?id=wgppdwdx8dq!./src/components/leaf-relief/Selector.vue
// module id = 629
// module chunks = 0